import { Alert, Button } from "react-bootstrap";
import { Modal } from "../../../components";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { useEffect } from "react";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { format, parseISO } from "date-fns";

const ModalVerMotivo = () => {

    //? ESTADOS GLOBALES
    const { alertasBloqueo, alertasNoBloqueo, archivos, acta } = useActaDetalleStore();
    const { modals, handlerModal } = useGeneralAppStore();

    // console.log(acta)
    // console.log(archivos)

    useEffect(() => {
        return () => {
            handlerModal({ modal: false, modalName: "ver_motivo" })
        }
    }, [])

    return (
        <>
            <Modal
                show={modals.includes('ver_motivo')}
                size={"lg"}
                onHide={() => handlerModal({ modal: false, modalName: "ver_motivo" })}
                title={() => "Motivo no notificada"}
            >
                <div className="d-flex align-items-start gap-3 px-4">
                    <Alert variant="warning" className="d-flex flex-column gap-2 align-items-center col-6">
                        <div className="bg-white d-flex flex-column align-items-center gap-2 p-4 border rounded shadow-lg w-100">
                            <p className="fw-bold m-0">Acta sin entregar</p>
                            <p className="m-0">Motivos</p>
                            {
                                acta?.motivo_no_notificado?.map((motivo, index) => {
                                    return (
                                        <div key={index} className="d-flex gap-2">
                                            <p className="m-0">{motivo?.motivo}</p>
                                            <p className="m-0">{format(parseISO(motivo?.fecha_no_notificado), 'dd/MM/yy HH:mm')}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Alert>
                    <div className="col-6">
                        {
                            archivos?.fotoNoNotifciada?.length > 0 &&
                            <div className="w-100 overflow-hidden">
                                <img src={archivos?.fotoNoNotifciada[archivos?.fotoNoNotifciada?.length - 1]?.file} alt="foto-no-notificada " className="w-100 " style={{ objectFit: "contain", aspectRatio: "3/4" }} />
                            </div>
                        }
                    </div>
                </div>

                {/* <object data={archivos?.aviso?.file} type="application/pdf" className="w-100" style={{ aspectRatio: "3/4" }}></object> */}
            </Modal>
        </>
    );
}
export default ModalVerMotivo;